// REAL Design tokens from Figma - Rash ID Brand Colors
export const designTokens = {
  colors: {
    // Text Colors (from Figma)
    text: {
      primary: '#122342',
      secondary: '#48556d',
      tertiary: '#808998',
      quaternary: '#ffffff',
    },
    
    // Background Colors (from Figma)
    background: {
      primary: '#081122',
      tertiary: '#808998',
      quaternary: '#e4e4e4',
      quinary: '#ebebeb',
      senary: '#eeeeee',
      octonary: '#ffffff',
    },
    
    // Brand Colors (from Figma)
    brand: {
      blue: {
        primary: '#7ADFA3',
        light: '#98DE79',
        dark: '#6EC491',
      },
      yellow: {
        lightMax: '#EFFBF4',
      },
      pink: {
        lightMax: '#EFFBF4',
      },
    },
    
    // Additional Colors (from Figma)
    semantic: {
      error: '#DF7C7A',
      attention: '#fad826',
      warning: '#DF9A7A',
    },
    
    // Border Colors (from Figma)
    border: {
      secondary: '#EFFBF4',
    },
    
    // Shades (from Figma)
    shades: {
      16: '#08112229',
      24: '#0811223d',
    },
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    '2xl': 32,
    '3xl': 40,
    '4xl': 64,
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    fontSize: {
      sm: 14,
      md: 16,
      lg: 18,
      xl: 38,
    },
    fontWeight: {
      medium: 500,
      semiBold: 600,
    },
    lineHeight: {
      sm: 22,
      md: 24,
      lg: 36,
    },
  },
  borderRadius: {
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    max: 999,
  },
} as const;